import { attendeeFetchData } from "./index";

const attendeeCertificateAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/agenda/certificates`),
  fetchCertificateDetails: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/certificate/details`),
}

export default attendeeCertificateAPI;